import { oadInterceptor, getOadParams, getFrontCardParams, oadLX } from '@mtfe/sweet-oad';

const { post, get } = oadInterceptor;
const actId = 'cpsNewH5Coupon';

// let MOCK_URL = 'https://yapi.sankuai.com/mock/20179';
let MOCK_URL = '';
const HREF = window.location.href;
// 防止发布到线上
if (
    HREF.includes('meituan.com') ||
    HREF.includes('st.meituan.com') ||
    HREF.includes('waimai.st.sankuai.com')
) {
    MOCK_URL = '';
}

const version = 'collection_waimai_v5';

const _reportLX = (url, error) => {
    oadLX.mv('b_waimai_wunt28uk_mv', {
        custom: {
            url,
            error: error.message || JSON.stringify(error),
        },
    });
};

// 中间页cookie处理请求
const actGeHandleCookie = async (isLoginJust) => {
    const rest = await getOadParams();

    const data = {
        front_card_params: getFrontCardParams(),
        ...rest,
    };

    if (isLoginJust) {
        data.login = true;
    }
    const url = '/act/ge/handle_cookie';
    try {
        const res = await post({
            url,
            data,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        throw error;
    }
};

// 点击上报后端
const actGeClkM = async (clickMonitorUrl) => {
    const url = `https:${clickMonitorUrl}`;
    try {
        const res = await get({
            url,
            disableDefaultToast: true,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        throw error;
    }
};
/**
 * 曝光上报后端
 * @param {*} impMonitorUrl
 * @returns
 */
const gMonitorApi = async (impMonitorUrl) => {
    const url = `https:${impMonitorUrl}`;
    try {
        const res = await get({
            url,
            disableDefaultToast: true,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        throw error;
    }
};

/**
 * 批量领券
 * @param {*} giftIds
 * @returns
 */
const actGeRecvVer4Multi = async (giftIds, recallBizId = '') => {
    const rest = await getOadParams();
    const url = `${MOCK_URL}/act/ge/recv_ver4_multi`;
    const data = { ...rest, giftIds };

    if (recallBizId) {
        data.recallBizId = recallBizId;
    }
    if (MOCK_URL) {
        data.version = version;
    }

    try {
        const res = await post({
            url,
            data,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        throw error;
    }
};

/**
 * 组件化poi检索接口
 * @param {*} recallBizId 商家召回逻辑ID
 * @param {*} pageNo 滚动加载页码
 * @returns
 */
const actGetPoiList = async (recallBizId, pageNo) => {
    const rest = await getOadParams();
    const url = `${MOCK_URL}/act/ge/queryPoiByRecallBiz`;

    const data = {
        ...rest,
        pageNo,
        recallBizId,
        channelType: 'SELF',
    };
    if (MOCK_URL) {
        data.version = version;
    }

    try {
        const res = await post({
            url,
            data,
            useH5Guard: true
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        throw error;
    }
};
/**
 * 活动页面tab列表查询
 */
const getCategoryInfo = async () => {
    const rest = await getOadParams();

    const url = `${MOCK_URL}/act/ge/getShowCateList`;

    const data = {
        ...rest,
        actId,
    };
    if (MOCK_URL) {
        data.version = version;
    }

    try {
        const res = await post({
            url,
            data,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        throw error;
    }
};

/**
 * 活动页面结构信息查询
 */
const getStructConfig = async () => {
    const rest = await getOadParams();
    const url = `${MOCK_URL}/act/ge/getStructConfig`;

    const data = {
        ...rest,
        actId,
    };
    if (MOCK_URL) {
        data.version = version;
    }
    try {
        const res = await post({
            url,
            data,
        });
        return res;
    } catch (error) {
        // 接口异常上报
        _reportLX(url, error);
        throw error;
    }
};

/**
 * 前端页面状态上报接口
 * @param {*} domId - 生成传递给后端的domID字符串，该字符串用来描述页面实际展示的结构。
 * @param {*} expInfoParams - 实验参数，透传后端给的参数
 * @param {*} LXPageId - 上报灵犀的页面ID
 * @returns
 */
const frontMonitorPageLog = async (domId, expInfoParams, LXPageId) => {
    const rest = await getOadParams();
    const url = `${MOCK_URL}/act/frontMonitor/pagelog`;
    try {
        const data = { ...rest, domId, expInfoParams, LXPageId, actId };
        const res = await post({
            url,
            data,
            disableDefaultToast: true,
        });
        return res;
    } catch (error) {
        _reportLX(url, error);
        throw error;
    }
};

const http = {
    actGeHandleCookie,
    actGeClkM,
    actGeRecvVer4Multi,
    gMonitorApi,
    actGetPoiList,
    getCategoryInfo,
    getStructConfig,
    frontMonitorPageLog,
};

export default http;
